// extracted by mini-css-extract-plugin
module.exports = {"item":"item--2aW0b","imageWrap":"imageWrap--2q6yW","mask":"mask--1nqKe","describe":"describe--3evo1","title":"title--LU2kl"};